export default __webpack_public_path__ + "static/media/fasting_noworries@2x.5f33ad10.jpg";